<app-update-add-table
  [config]="config"
  [element_name]="element_name"
  [path]="path" 
  [form_add]="showFormAdd"
  [showDeleteButton]="showDeleteButton"
  [showUpdateButton]="showUpdateButton"
  
  [title]="title" 
  [description]="description" >
  <app-update-add-table>